import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47692c1e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "share-weixin"
};
const _hoisted_2 = {
  class: "share-weibo"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "share-tit"
}, "分享至", -1));
const _hoisted_4 = {
  class: "flex"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: "https://p6.moimg.net/mdwxapp/share_sina_icon.png"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微博", -1));
const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: "https://p6.moimg.net/mdwxapp/share_zone_icon.png"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "QQ空间", -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = ["copyData"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: "https://p6.moimg.net/mdwxapp/share_copyLink_icon.png"
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制链接", -1));
const _hoisted_14 = [_hoisted_12, _hoisted_13];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("section", null, [_createElementVNode("div", {
    class: "back-mask-keep",
    onClick: _cache[0] || (_cache[0] = $event => $options.onShare()),
    onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
  }, null, 32), _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [[_vShow, $options.env.isWeixin()]]), _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [[_vShow, $options.env.isWeibo()]]), _withDirectives(_createElementVNode("div", {
    class: "share-container",
    onTouchmove: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
  }, [_hoisted_3, _createElementVNode("dl", _hoisted_4, [_createElementVNode("dd", {
    class: "weibo",
    onClick: _cache[2] || (_cache[2] = $event => $options.share_weibo())
  }, _hoisted_7), _createElementVNode("dd", {
    class: "qq-zone",
    onClick: _cache[3] || (_cache[3] = $event => $options.share_qq())
  }, _hoisted_10), _createElementVNode("dd", {
    class: "copy-url",
    ref: "copyUrl",
    copyData: _ctx.mall_share.share_info.sharelink_url
  }, _hoisted_14, 8, _hoisted_11)]), _createElementVNode("div", {
    class: "share-cancel",
    onClick: _cache[4] || (_cache[4] = $event => $options.onShare())
  }, "取消")], 544), [[_vShow, !$options.env.isWeixin() && !$options.env.isWeibo()]])], 512)), [[_vShow, _ctx.mall_share.showShare]]);
}